import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectPageView = createSelector(
  (state: RootState) => state.page.pageView,
  (pageView: string) => pageView
)

export default selectPageView
